import React from 'react';
import { Helmet } from 'react-helmet-async';

import PageTitleSection from '../../components/PageTitleSection/PageTitleSection';
import GeneralTab from './GeneralTab/GeneralTab';
import ChatbotStylingTab from './ChatbotStylingTab/ChatbotStylingTab';
import DataRetentionTab from './DataRetentionTab/DataRetentionTab';
import AiSettingsTab from './AiSettingsTab/AiSettingsTab';
import BuildBotButton from '../../components/BuildBotButton/BuildBotButton';
import PageContentContainer from '../../components/PageContentContainer/PageContentContainer';
import CustomTabs from '../../components/CustomTabs/CustomTabs';

function ChatbotSettingsPage(): React.ReactElement {
  const [selectedTab, setSelectedTab] = React.useState('general');

  return (
    <>
      <Helmet>
        <title>Japeto - Settings</title>
      </Helmet>
      <PageTitleSection title='Settings'>
        <BuildBotButton />
      </PageTitleSection>
      <PageContentContainer>
        <CustomTabs
          tabs={[
            {
              label: 'General',
              value: 'general',
              content: <GeneralTab />
            },
            {
              label: 'Styling',
              value: 'styling',
              content: <ChatbotStylingTab />
            },
            {
              label: 'Data Retention',
              value: 'data-retention',
              content: <DataRetentionTab />
            },
            {
              label: 'AI',
              value: 'ai',
              content: <AiSettingsTab />
            }
          ]}
          defaultValue='general'
          value={selectedTab}
          onValueChange={setSelectedTab}
          hasContentBox
        />
      </PageContentContainer>
    </>
  );
}

export default ChatbotSettingsPage;
